import React from 'react'
import ScrollUpButton from 'react-scroll-up-button'

import styled from 'styled-components'

import UpIcon from 'assets/images/svg/button-next-up.svg'

const ScrollUpBtn = () => {
  return (
    <Container>
      <ScrollUpButton
        style={{
          backgroundImage: `url(${UpIcon})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          padding: 8,
          borderRadius: 50,
          width: 60,
          height: 60,
        }}
      />
    </Container>
  )
}

export default ScrollUpBtn

const Container = styled.div`
  aside {
    background-color: transparent !important;
    right: 35px !important;
    bottom: 35px !important;
  }
  aside svg {
    display: none !important;
  }
`
